import { inputCommon } from '../inputCommon'
import type { FieldInputProps } from '../types'

export function TextInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <input
      type="text"
      id={`field-${field.fieldCode}`}
      className={inputCommon(disabled)}
      disabled={disabled}
      value={value === null || value === undefined ? '' : String(value)}
      onChange={e => onChange(e.target.value)}
    />
  )
}
